(ns minorodata.connections.sources.supportpal
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string       :as cstr]
            [cljs.spec.alpha      :as spec]
            [spec-tools.core      :as tools]
            [mold-forms.core      :as form-component]))

(def url-pattern #"(?i)^(?:(?:https?)://)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$")

(defn url? 
  [input]
  (re-matches url-pattern input))

(spec/def ::server-url
  (spec/and (tools/spec url? {:reason "Please provide a valid URL (eg: https://example.com)"})
            (tools/spec (complement cstr/blank?) {:reason "Server URL can't be empty"})))

(spec/def ::supportpal-form
  (spec/and
    (spec/keys :req-un [::server-url])))

(def source
  {:id           "supportpal"
   :enabled      true
   :name         "Supportpal"
   :description  "Powerful on-premise web-based customer support software"
   :image-source "supportpal.png"
   :tags         ["data-import"]

   :preview-formatter (fn [] "")

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [name description api-token server-url]} data]
        {:source-type "supportpal"
         :name        name
         :description description

         :source
         {:credentials         {:type                   "token"
                                :api-token              api-token}
          :server-url          server-url}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials server-url]} source]
        (merge
         (select-keys credentials [:api-token])
         {:name              name
          :description       description
          :server-url        server-url})))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (partial form-component/validate-form ::supportpal-form)

    :id :supportpal-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Server URL"
              :name       :server-url
              :required   true
              :value      ""}
             {:block-type :input
              :label      "API Token"
              :required   true
              :name       :api-token
              :type       :password
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action extra-params destination-table report
                 backfill-months num-message-tickets advanced-options start-date end-date]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:report            report
                    :destination-table destination-table
                    :num-message-tickets num-message-tickets
                    :backfill-months   backfill-months
                    :advanced-options  advanced-options
                    :start-date        start-date
                    :end-date          end-date
                    :action            action
                    :extra-params      extra-params}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:report :action :destination-table :backfill-months :extra-params :num-message-tickets :advanced-options :start-date :end-date])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status}))))

    :validate (constantly nil)

    :id :supportpal-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    [{:name "Tickets" :value "ticket"}
                           {:name "Messages" :value "message"}]
              :required   true
              :value      "ticket"}

             {:block-type :select
              :label      "Backfill Months"
              :name       :backfill-months
              :options    [{:name "1 Month"    :value 1}
                           {:name "2 Months"   :value 2}
                           {:name "3 Months"   :value 3}]
              :required   true
              :value      1
              :doc        [:span "Large backfills for messages can cause extracts to take a long time or fail"]}

             {:block-type :input
              :label      "Num of ticket messages to ingest"
              :name       :num-message-tickets
              :value      "200000"
              :conditions [[:eq [:report :value] "message"]]}

             {:content "If the number of tickets specified above is too large, the extract may fail"
              :conditions [[:eq [:report :value] "message"]]}

             {:block-type :checkbox
              :label      "Advanced options"
              :name       :advanced-options
              :type       :checkbox
              :value      false
              :conditions [[:eq [:report :value] "ticket"]]}

             {:block-type :date-picker
              :label      "From"
              :name       :start-date
              :required   false
              :conditions [[:and [[:report :value] [:advanced-options :value]] ["ticket" true]]]}

             {:block-type :date-picker
              :label      "To"
              :name       :end-date
              :required   false
              :conditions [[:and [[:report :value] [:advanced-options :value]] ["ticket" true]]]}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :input
              :label      "Extra parameters in query parameter syntax"
              :required   false
              :name       :extra-params
              :value      ""}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
